<div class="mb-grid-container-full">
  @if (hasDiningCard && !expanded) {
    <div class="dining-card">
      <div>
        <p class="dining-card__title">
          {{ diningCardTitle }}
        </p>
        @if (!isFreeMealPlan) {
          <p class="dining-card__text">
            Obtené este beneficio sumando a tu reserva 4 o más días en los parques. Solo se puede usar para comprar
            alimentos y bebidas.
          </p>
        } @else {
          <p class="dining-card__text">
            Sumando a tu reserva 4 o más días en los parques con entradas <i>Park Hopper o Park Hopper Plus</i>.
          </p>
        }
      </div>
      <mb-icon icon="magic"></mb-icon>
    </div>
  }

  <div class="room-summary" [class.room-summary--expanded]="expanded" [class.dining-card__border]="hasDiningCard">
    <div class="room-summary__header-wrapper">
      @for (room of cluster.rooms; track room.id; let i = $index; let last = $last) {
        <div class="room-summary__header-wrapper__header">
          <am-room-information
            [room]="room"
            [hideImage]="expanded"
            [useCompactStyle]="cluster.rooms.length > 1"
            [lastRoom]="last"
          >
            @if (!isMultiRoom) {
              <div [hidden]="expanded">
                <ng-container [ngTemplateOutlet]="clusterDetails"></ng-container>
              </div>
            }
          </am-room-information>
          @if (i === 0) {
            <mb-icon
              [icon]="expanded ? 'arrow-up' : 'arrow-down'"
              (click)="onClick()"
            ></mb-icon>
          } @else {
            <div class="empty-wrapper"></div>
          }
        </div>
      }
    </div>

    @if (isMultiRoom) {
      <div [hidden]="expanded">
        <ng-container [ngTemplateOutlet]="clusterDetails"></ng-container>
      </div>
    }
  </div>
</div>

<ng-template #clusterDetails>
  @if (isDisney$ | async) {
    <div class="room-summary__disney-supplements">
      <am-disney-supplements [supplements]="disneySupplements$ | async">
      </am-disney-supplements>
    </div>
  } @else {
    <div class="room-summary__payment-methods">
      <am-payment-methods [badges]="paymentMethods$ | async"> </am-payment-methods>
    </div>
    <div class="room-summary__meal-plans">
      <am-meal-plans [mealPlansBadges]="mealPlans$ | async"> </am-meal-plans>
    </div>
  }

  @if (bestPrice) {
    <div class="room-summary__best-price">
      A partir de
      <span class="room-summary__best-price__price">$ {{ bestPrice | Currency }}</span>
      {{ priceBy === ROOM_PRICE.BY_NIGHT ? '/por noche' : '' }}
    </div>
  }
</ng-template>